import { appConfig as $config } from '../../app.config';
import { App } from '../App';
import { UI } from '../UI';
import { assetsManager } from '../../modules/assetsManager/artworks';
import { Common } from '../../modules/Common';
import { Artworks } from '../../pages/Artworks';

import './scss/artworkinfo.scss';
import { ApprovalRejection } from '../ApprovalRejection';
import { SortFilter, User } from '../../index';

export const ArtworkInfo = (function () {
  let blanksColumns = [
    {
      data: null,
      width: 30,
      defaultContent: '',
      className: 'control',
      orderable: false,
      sortable: false,
      responsivePriority: 0
    },
    {
      title: $Lang.artwork.SelectedBlanks,
      data: 'imageExistsUri',
      render: (data, type, full) => {
        return `<div class="d-flex align-items-center">${UI.thumbnail(data)}<div class="pl-3">${
          full.title
        }</div></div> `;
      }
    },
    {
      title: $Lang.artwork.CategorySubCategory,
      data: 'category',
      render: (data, type, full) => {
        return `${data}${
          full.subCategory && full.subCategory != null
            ? '<i class="fal fa-angle-right mx-2"></i>' + full.subCategory
            : ''
        }`;
      }
    },
    { title: $Lang.artwork.DefaultMockupPanel, data: 'defaultMockupPanel' },
    { title: $Lang.artwork.Brand, data: 'brand' },
    { title: $Lang.artwork.BrandCode, data: 'brandCode' },
    {
      title: $Lang.artwork.Statuses,
      data: 'approveItem',
      render: (data, type, full) => {
        let out = '';
        if (full.isApproveFromAccountSettings) {
          out += `<div class="d-inline-block text-success mr-4"><i class="far fa-check-circle"></i> ${$Lang.blanks.Selected}</div> `;
        } else {
          out += `<div class="d-inline-block text-success mr-4"><i class="far fa-check-circle"></i> ${$Lang.blanks.SelectedFromArtwork}</div> `;
        }
        if (data) {
          if (data.approved != null && data.approved != undefined && data.approved == 1) {
            out += `<div class="d-inline-block text-success"><i class="far fa-file-signature"></i> ${$Lang.blanks.Approved}</div> `;
          } else if (data.approved != null && data.approved != undefined && data.approved == 2) {
            out += `<div class="d-inline-block text-danger"><i class="far fa-file-times"></i> ${$Lang.blanks.Rejected}</div> `;
          }
        }
        return out;
      }
    },
    {
      title: $Lang.artwork.SelectedColors,
      data: null,
      render: (data, type, full) => {
        let out = '';
        full.variants
          .filter((f) => f.select)
          .forEach((variant) => {
            out += `<span class="d-inline-block kt-badge--bbw-color" style="background-color:${
              variant.colorHex != '' ? variant.colorHex : variant.color
            }"></span> `;
          });
        return out;
      }
    }
  ];

  let mapping = {
    data: (data) => {
      return {
        infoDialog: true,
        id: data.id,
        accountId: data.accountId,
        title: data.title,
        account: data.accountName,
        image: data.thumbnailImageUri,
        createdDate: moment(data.createdDate).format($config.appFullDateFormat),
        brand: data.brand,
        subbrand: data.subbrand,
        artworkId: data.standartId,
        designer: data.designer,
        licensor: data.licensor,
        version: data.version,
        brief: data.brief || 'none',
        description: data.description,
        files: data.files,
        screenPrintingFiles: data.screenPrintingFiles,
        checkedPartTypes: data.checkedPartTypes,
        status: data.status,
        styleGuide: data.styleGuide,
        pantones: data.pantones,
        trims: $.map(data.selectTrims, (trim) => {
          return trim.title;
        }).join(', '),
        stamps: $.map(data.selectStamps, (stamp) => {
          return stamp.title;
        }).join(', '),
        printers: '',
        minPrice: data.minPrice ? data.minPrice.currencyValue + '' + data.minPrice.currencyCode : '',
        licensorRoyalty: data.royalty,
        licenseeRoyalty: data.royalty,
        agentRoyalty: data.royalty,
        stores: data.selectDistributionChannels?.join(', '),
        blanks: data.selectBlanks,
        distributionTerritories: data.licensorRestrictions?.territories?.join(', '),
        tags: data.tags,
        bulletPoints: data.bulletPoints,
        collections: data.collections,
        externalId: data.externalId,
        versionFiles: data.versionFiles,
        versionFilesNumber: data.versionFiles?.length,
        versionFilesThumbnails: data.versionFiles?.map((v) => v.thumbnailImageUri),
        defaultThumbnail: data.versionFiles?.[0]?.thumbnailImageUri,
        // Approval Item mapping
        approveItem: Common.mapping.approvalObject(data.approveItem),
        blankCategories: (data?.selectBlanks || [])
          .map((blank) => {
            return {
              category: blank.category ? blank.category.trim() : '',
              subCategory: blank.subCategory ? blank.subCategory.trim() : ''
            };
          })
          .sort(function (a, b) {
            return a.category > b.category;
          })
          .reduce(function (accumulator, currentValue) {
            if (
              !accumulator.find(
                (item) => item.category == currentValue.category && item.subCategory == currentValue.subCategory
              )
            ) {
              accumulator.push(currentValue);
            }

            return accumulator;
          }, []),
        containsLegalTagLineText: data.containsLegalTagLine ? $lang.btn.yes : $lang.btn.no,
        printType: data.printType,
        relations: data.relations,
        relatedMockups: `${data.relations?.mockupsCount || 0} ${data.relations?.mockupsCount === 1 ? $lang.artworkinfo.Mockup : $lang.artworkinfo.Mockups}`,
        relatedProducts: `${data.relations?.productsCount || 0} ${data.relations?.productsCount === 1 ? $lang.artworkinfo.Product : $lang.artworkinfo.Products}`,
        artworkType: data.artworkType,
      };
    }
  };

  let reloadPage;

  let dialog = (id = false, callback, readOnly = false, accountId = '') => {
    if (!id) return;
    reloadPage = callback;
    UI.blockPage();

    $.when(App.ajaxData(`/Artworks/${accountId}/${id}`)).done((res) => {
      if (!res.isSuccess) {
        return UI.errorMessage(res.errorInformation.errorReason);
      }
      let artwork = mapping.data(res.object);
      let areaSizes = res.defaults.find((def) => def.key === 'ImageAreaSize').values;
      let data = {
        $lang: $Lang,
        artwork,
        readOnly,
        areaSizes,
        isLicensor: User.isLicensor(),
      };

      let template = require('./tmpl/dialog.hbs');
      bootbox
        .dialog({
          title: $lang.artworkinfo.ArtworkInformation,
          message: template(data),
          size: 'xl',
          className: 'modal-scrolled-content modal-artwork-information'
        })
        .init(() => {
          init(artwork, areaSizes, User.accountID());
        })
        .on('shown.bs.modal', () => {
          $(window).trigger('resize');
        });
    });
  };

  let init = (data = {}, areaSizes = null, accountId) => {
    let wrap = $('.artwork-information-content');

    UI.unblockPage();

    assetsManager.init({
      files: [...data.files, ...data.screenPrintingFiles],
      versionFiles: data.versionFiles,
      screenPrintingFiles: data.screenPrintingFiles,
      checkedPartTypes: data.checkedPartTypes,
      pageType: 'ArtworksInfo',
      areaSizes: areaSizes,
      infoMode: true
    });

    $('#artworkBlanksTbl').DataTable({
      columns: blanksColumns,
      data: data.blanks,
      responsive: {
        details: {
          type: 'column',
          target: 0
        }
      },
      pageLength: 25,
      cache: false,
      searching: false,
      ordering: false,
      sorting: false,
      dom: '<"row"<"col text-right"p>><"row"<"col"t>>', //<"row"<"col"B>>
      drawCallback: () => {
        UI.unblock('#page');
        // Image popup
        $('.magnific-image').magnificPopup({ type: 'image' });
      },
      initComplete: () => {}
    });

    wrap
      .off()
      .on('click', '.js-action-edit', () => {
        bootbox.hideAll();
        $router.push(`/artworks/${data.id}/${data.accountId}/edit-${data.artworkType?.toLowerCase?.()}`);
      })
      .on('click', '.js-action-approve-reject', () => {
        ApprovalRejection.dialog({
          items: { [data.id]: data.accountId },
          page: 'artworks',
          callback: () => {
            reloadDialog(data.id, accountId);
          }
        });
      })
      .on('click', '.js-action-download', () => {
        document.location.href = `${$config.apiURL}/artworks/download/${accountId}/${data.id}`;
      })
      .on('click', '.js-action-create', () => {
        bootbox.hideAll();
        Artworks.submitClickHandler(data.id);
      })
      .on('click', '.js-action-delete', () => {
        bootbox.hideAll();
        Artworks.deleteArt(data.id);
      })
      .on('click', '.artwork-relations', (event) => {
        const target = $(event.currentTarget).data('aid');

        let page;
        let filter;

        if (target === 'mockups' && data?.relations?.mockupsFilter?.filterItem?.internalName) {
          filter = data?.relations?.mockupsFilter;
          page = 'prelistings';
        }

        if (target === 'products' && data?.relations?.productsFilter?.filterItem?.internalName) {
          filter = data?.relations?.productsFilter;
          page = 'listings';
        }

        if (!page || !filter) {
          return;
        }

        SortFilter.setFilters(page, [{
          internalName: filter?.filterItem?.internalName,
          displayName: filter?.filterItem?.displayName,
          filterTypeName: filter?.filterItem?.filterTypeName,
          values: (filter?.filterItem?.defaultValues || []).map(v => ({ name: v.title, value: v.value }))
        }]);

        $router.push(`/${page}`);
      });

    $('[data-toggle="kt-tooltip"]').tooltip();

    $('.owl-carousel', wrap).owlCarousel({
      autoWidth: true,
      mouseDrag: false,
      dots: false,
      nav: true
    });

    $('.c-pic', wrap).on('click', function () {
      const thisimg = $(this).data('imguri');
      const parent = $(this).closest('.image-carousel');
      const bigimg = $(this).closest('.img-content').find('.img-bg-square');

      $('.active-image', parent).removeClass('active-image');
      $(this).addClass('active-image');
      bigimg.css({ backgroundImage: `url(${thisimg})` });
    });
  };

  let reloadDialog = (id, accountId = '') => {
    if (!id) return;
    UI.blockPage();


    $.when(App.ajaxData(`Artworks/${accountId}/${id}`)).done((res) => {
      let artwork = mapping.data(res.object);
      let data = {
        $lang: $Lang,
        artwork: artwork,
        isLicensor: User.isLicensor(),
      };

      let template = require('./tmpl/dialog.hbs');

      UI.render('.modal-body .bootbox-body', template, data).then(() => {
        init(artwork, null, accountId);
        UI.unblock('.modal-content');
        reloadPage();
      });
    });
  };

  return {
    dialog,
    reloadDialog
  };
})();
